import React from "react";
import { Switch } from "react-router-dom";
import Landing from "../../pages/Landing/Landing";
import About from "../../pages/About/About";
import Login from "../../pages/Auth/Login";
import SignUp from "../../pages/Auth/SignUp";
import ForgotPassword from "../../pages/Auth/ForgotPassword";
import ResetPassword from "../../pages/Auth/ResetPassword";
import VerifyAccount from "../../pages/Auth/VerifyAccount";
import Dashboard from "../../pages/Dashboard";
import Messages from "../../pages/Messages";
import Room from "../../pages/Room";
import PreRoomSetup from "../../pages/Room/PreRoomSetup";
import SpectateRegularMode from "../../pages/Spectate/RegularMode";
import SpectateGuestMode from "../../pages/Spectate/GuestMode";
import GuestSpectateDashboard from "../../pages/Spectate/GuestDashboard";
import Account from "../../pages/Account";
import NotificationList from "../../components/Notifications/NotificationList";
import BookmarkedRooms from "../../components/Bookmarks/BookmarkedRooms";
import SettingsPage from "../../pages/Settings";
import HybridRoute from "./HybridRoute";
import { ROUTES } from "./paths";

const router = () => (
  <Switch>
    {/* Public Pages */}
    <HybridRoute exact path={ROUTES.root} render={() => <Landing />} />
    <HybridRoute exact path={ROUTES.landing} render={() => <Landing />} />
    <HybridRoute exact path={ROUTES.about} render={() => <About />} />

    {/* Auth Pages */}
    <HybridRoute exact path={ROUTES.login} render={() => <Login />} />
    <HybridRoute exact path={ROUTES.register} render={() => <SignUp />} />
    <HybridRoute
      exact
      path={`${ROUTES.forgotPassword}`}
      render={() => <ForgotPassword />}
    />
    <HybridRoute
      exact
      path={`${ROUTES.resetPassword}`}
      render={() => <ResetPassword />}
    />
    <HybridRoute
      exact
      path={`${ROUTES.verifyAccount}`}
      render={() => <VerifyAccount />}
    />
    <HybridRoute
      exact
      path={`${ROUTES.dashboard}`}
      render={() => <Dashboard />}
    />
    <HybridRoute
      exact
      path={`${ROUTES.messages}/:username`}
      render={() => <Messages />}
    />
    <HybridRoute
      exact
      path={`${ROUTES.messages}`}
      render={() => <Messages />}
    />
    <HybridRoute
      exact
      path={ROUTES.notifications}
      render={() => <NotificationList />}
    />
    <HybridRoute
      exact
      path={ROUTES.bookmarks}
      render={() => <BookmarkedRooms />}
    />
    <HybridRoute
      exact
      path={ROUTES.settings}
      render={() => <SettingsPage />}
    />
    <HybridRoute
      exact
      path={`${ROUTES.roomSetup}`}
      render={() => <PreRoomSetup />}
    />
    <HybridRoute
      exact
      path={`${ROUTES.spectate}`}
      render={() => <GuestSpectateDashboard />}
    />
    <HybridRoute
      exact
      path={`${ROUTES.spectate}/:id`}
      render={() => <SpectateRegularMode />}
    />
    <HybridRoute
      exact
      path={`${ROUTES.spectateGuest}/:id`}
      render={() => <SpectateGuestMode />}
    />
    <HybridRoute exact path={`${ROUTES.rooms}/:id`} render={() => <Room />} />
    
    {/* User profile - catches any other single-segment paths */}
    <HybridRoute exact path="/:searchedUsername" render={() => <Account />} />
  </Switch>
);

export default router;
